// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610131707/js/" + chunkId + "." + {"44":"76dbccf7","225":"81c1f0c1","481":"69710c5a","486":"787303e9","770":"2786f4d9"}[chunkId] + ".0.8670648104726664.chunk.js";
};